import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import { LoadingIndicator } from 'common/components/preloader';
import IdValidation from 'account/containers/id_verification/id_validation';
import WorkSamples from 'account/containers/id_verification/work_samples';

/**
 * Creative's ID verification status.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class IdVerification extends Component {
  componentDidMount() {
    this.props.fetchIdPhotoIfNeeded(true)
  }

  renderDraft() {
    const { idValidated, reopenedAt } = this.props;

    return (
      <div>
        { idValidated &&
        <div>
          { this.renderSubmittedAt() }
          <IdValidation />
          <h3>Work Samples Verification</h3>
        </div> }

        <div className="draft">
          <div className="status text-warning">
            <i className="fa fa-file-text-o" /> In progress
          </div>
          <p>
            You haven't completed your application yet.<br />
            Click the button below to complete it.
          </p>
          <Link to="/register/continue/" className="btn btn-tertiary btn-block">
            Complete application
          </Link>
        </div>

        { reopenedAt && <WorkSamples /> }
      </div>
    );
  }

  renderSubmitted() {
    const { reopenedAt, idValidated } = this.props;

    return (
      <div>
        { idValidated &&
        <div>
          { this.renderSubmittedAt() }
          <IdValidation />
          <h3>Work Samples Verification</h3>
        </div> }

        <div className="submitted">
          <div className="status text-warning">
            <i className="fa fa-search" /> Pending Review
          </div>
          <p>
            Our team will review your application, including the work samples you
            <br className="hide-for-small-only"/> submitted. <strong>This review process
            typically takes 7 to 14 days.</strong>
          </p>
          { !reopenedAt &&
          <p>
            You will not be able to submit work to any projects until
            your <br className="hide-for-small-only"/> application has been approved.
          </p> }
          <p>
            We'll email you after we review your application. Please be
            patient<br className="hide-for-small-only"/> and do not contact our
            team <strong>unless more than 21 days have<br className="hide-for-small-only"/> passed
            </strong> since you submitted your application.
          </p>
          <p>
            In the meantime, visit our <Link to="/help/">FAQs for creatives</Link> to learn more
            about our <br className="hide-for-small-only"/> rules, policies, and working on
            crowdspring.
          </p>
        </div>

        { reopenedAt && <WorkSamples /> }
      </div>
    );
  }

  renderContent() {
    const { status } = this.props;

    if (!status || status === "draft") {
      return this.renderDraft();
    }

    if (status === "submitted") {
      return this.renderSubmitted();
    }

    return (
      <div>
        { this.renderSubmittedAt() }

        <IdValidation />

        <WorkSamples />
      </div>
    );
  }

  renderSubmittedAt() {
    const { submittedAt } = this.props;

    if (!submittedAt) {
      return null;
    }

    return (
      <h5 className="submitted-at">
        Submitted: { moment(submittedAt).format('MM/DD/YYYY h:mma') }
      </h5>
    );
  }

  render() {
    const { fetching } = this.props;

    return (
      <div id="content" className="l-content id-verification">
        { fetching?
        <LoadingIndicator /> :
        <div className="row">
          <div className="columns large-12 small-16">
            <h3>Identity Verification</h3>

            { this.renderContent() }
          </div>
          <div className="columns large-4 small-16 additional-info">
            <h3 className="hide-for-large">Our Standards</h3>
            <p>
              In order to maintain our <Link to="/standards-of-conduct-creative/">community
              standards</Link> and ensure a safe, trusted environment for all parties,
              crowdspring verifies your identity.
            </p>
            <p>
              Verifying your identity protects you, your colleagues working on the platform,
              and clients. We take identity fraud very seriously. If you suspect fraud,
              please <Link to="/help/contact/">report it</Link> immediately.
              To learn more about ID verification, please visit
              our <Link to="/help/joining-and-verification/how-do-i-take-my-pictures-verification/">
              FAQ</Link> or <Link to="/help/contact/">contact our support team</Link>.
            </p>
          </div>
        </div> }
      </div>
    );
  }
}

IdVerification.propTypes = {
  fetchIdPhotoIfNeeded: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  idValidated: PropTypes.bool,
  reopenedAt: PropTypes.string,
  submittedAt: PropTypes.string,
  status: PropTypes.string,
};



// WEBPACK FOOTER //
// ./account/components/id_verification/index.jsx